export enum RawChatsStoreMode {
  UNREAD_ONLY = 'unreadOnly',
  SEARCH = 'search',
  ASSIGNED_TO_ME_ONLY = 'assignedToMeOnly',
  ASSIGNED_TO_ME_UNREAD_ONLY = 'assignedToMeOnlyUnreadOnly',
  ASSIGNED_TO_OTHER_ONLY = 'assignedToOtherOnly',
  ASSIGNED_TO_OTHER_UNREAD_ONLY = 'assignedToOtherOnlyUnreadOnly',
}

export default RawChatsStoreMode;